import QuestionLabel from '~/components/forms/questions/QuestionLabel';
import React from 'react';
import FileUpload from '~/components/FileUpload';
import { FormPart, part } from '~/lib/FormCssApi';

const FileUploadQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.CONTROL)}>
                <FileUpload
                    value={value}
                    onChange={setValue}
                    showName={true}
                    // Follows the theme's accent colour rather than Breely's
                    buttonClassName="themed-bg-light themed-text"
                />
            </div>
        </label>
    );
};

export default FileUploadQuestion;
